import React from 'react';
import {
  Chip,
  FormControlLabel,
  MenuItem,
  Stack,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ProviderField } from '@/types/FoodDelivery.interface';

interface Props {
  field: ProviderField;
  value: unknown;
  onChange: (key: string, value: unknown) => void;
  /** Bu alan sunucuda kayıtlı mı (secret alanlarda "boş bırakırsan korunur"). */
  saved?: boolean;
}

/**
 * Tek bir provider alanını tipine göre render eder (plan Faz 1.5).
 * Provider-agnostiktir: hangi alanların çıkacağını backend şeması belirler,
 * burada `if (provider === ...)` YOKTUR.
 */
const ProviderFieldInput: React.FC<Props> = ({
  field,
  value,
  onChange,
  saved
}) => {
  const helper = (
    <>
      {field.helpText}
      {saved && field.secret ? (
        <>
          {field.helpText ? ' — ' : ''}
          Kayıtlı; boş bırakırsanız korunur.
        </>
      ) : null}
    </>
  );

  if (field.type === 'boolean') {
    return (
      <Stack>
        <FormControlLabel
          control={
            <Switch
              checked={value === true}
              onChange={(e) => onChange(field.key, e.target.checked)}
            />
          }
          label={field.label}
        />
        {field.helpText && (
          <Typography variant="caption" color="text.secondary" sx={{ ml: 6 }}>
            {field.helpText}
          </Typography>
        )}
      </Stack>
    );
  }

  if (field.type === 'select') {
    return (
      <TextField
        select
        fullWidth
        label={field.label}
        value={(value as string) ?? (field.default as string) ?? ''}
        onChange={(e) => onChange(field.key, e.target.value)}
        helperText={helper}
        required={field.required}
      >
        {(field.options ?? []).map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  return (
    <TextField
      fullWidth
      type={
        field.type === 'password'
          ? 'password'
          : field.type === 'number'
            ? 'number'
            : 'text'
      }
      label={
        <Stack direction="row" spacing={1} alignItems="center" component="span">
          <span>{field.label}</span>
          {saved && !field.secret && (
            <Chip
              size="small"
              color="success"
              variant="outlined"
              label="kayıtlı"
            />
          )}
        </Stack>
      }
      value={(value as string | number) ?? ''}
      placeholder={
        saved && field.secret ? '•••••• (kayıtlı)' : (field.placeholder ?? '')
      }
      onChange={(e) =>
        onChange(
          field.key,
          field.type === 'number'
            ? e.target.value === ''
              ? ''
              : Number(e.target.value)
            : e.target.value
        )
      }
      helperText={helper}
      required={field.required && !saved}
    />
  );
};

export default ProviderFieldInput;
